import { createContext } from 'react';
export const PrescriptionTopContext = createContext({});
